export const DATEPICKER_HEADER_SET_DATES = 'DATEPICKER_HEADER_SET_DATES'
export const DATEPICKER_COMPARE_SET_DATE = 'DATEPICKER_COMPARE_SET_DATE'
